import { Injectable } from "@angular/core";

import { dbToDate, dbToFloat, dbToInt, dbToString } from "@dffedb/util";

import { FakturaStatus } from "../model/faktura-status.model";
import { FakturaDto } from "../model/faktura.dto";
import { Faktura } from "../model/faktura.model";

@Injectable({ providedIn: "root" })
export class FakturaMapper {
    constructor() {}

    public dtoToFaktura(dto: FakturaDto): Faktura {
        const result: Faktura = {
            afdeling: dbToInt(dto.afdeling),
            afdelingtekst: dbToString(dto.afdelingtekst),
            beloeb: dbToFloat(dto.beloeb),
            bemaerkning: dbToString(dto.bemaerkning),
            dokumentnr: dbToInt(dto.dokumentnr),
            dokumenttype: dbToInt(dto.dokumenttype),
            dokumenttypetekst: dbToString(dto.dokumenttypetekst),
            dokumentUrler: null,
            enheder: dbToInt(dto.enheder),
            fakturadato: dbToDate(dto.fakturadato),
            fakturanr: dbToString(dto.fakturanr),
            filtype: dbToInt(dto.filtype),
            fordeler: dbToString(dto.fordeler),
            forfaldsdato: dbToDate(dto.forfaldsdato),
            godkendere: dbToString(dto.godkendere),
            konteringstekst: dbToString(dto.konteringstekst),
            konteringstekst2: dbToString(dto.konteringstekst2),
            konteringstekst3: dbToString(dto.konteringstekst3),
            kreditornavn: dbToString(dto.kreditornavn),
            kreditornr: dbToInt(dto.kreditornr),
            modpost: dbToInt(dto.modpost),
            projekt: dbToInt(dto.projekt),
            projekttekst: dbToString(dto.projekttekst),
            rekvisitionsnr: dbToString(dto.rekvisitionsnr),
            status: this.numberToFakturaStatus(dbToInt(dto.status))
        };
        return result;
    }

    public numberToFakturaStatus(value: number): FakturaStatus {
        switch (value) {
            case 0:
                return FakturaStatus.Afventer;
            case 1:
                return FakturaStatus.Godkendt;
            case 2:
                return FakturaStatus.Afvist;
            default:
                return FakturaStatus.Afventer;
        }
    }
}
